import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { InputValue } from './inputs';

export type QueryParams = Record<string, InputValue>;
export type QueryParamsReducer = {
  inputs: QueryParams;
  experimentOverrides: QueryParams;
  excludeInstitution?: string[];
  isMobileApp?: boolean;
  auth0State?: string | string[];
  auth0AnonymousId?: string | string[];
  auth0Variant?: string | string[];
};
const initialState: QueryParamsReducer = {
  inputs: {},
  experimentOverrides: {},
  excludeInstitution: [],
  isMobileApp: false,
  auth0State: undefined,
  auth0AnonymousId: undefined,
  auth0Variant: undefined,
};

const queryParams = createSlice({
  name: 'queryParams',
  initialState,
  reducers: {
    setQueryParams(state, action: PayloadAction<QueryParamsReducer>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setQueryParams } = queryParams.actions;
export default queryParams.reducer;
